import primer from "../primer"

export default (getView) => (nextStepPath, failedCheckoutPath) => ({
  ...getView(nextStepPath),
  ...primer(),

  statusToTrack: "VISIT_CHECKOUT",

  onInit() {
    this.addConfirmationEventListener()
    this.initPrimer({
      checkoutCompletePath: nextStepPath,
      failedCheckoutPath: failedCheckoutPath,
      external: true,
    })
    this.store.restorePurchasedBasicOffer()
  },
})
